module.exports = __webpack_public_path__ + "img/AQ.a259d32f.png";